import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSendMessage } from '@games/api';
import messages from '../intl/messages';
import { ContactMeForm, ContactMeFormValues } from './ContactMeForm';

export const ContactMePage: React.FC = () => {
  const [{ loading, data }, sendMessage] = useSendMessage();

  const submit = (variables: ContactMeFormValues) => {
    sendMessage({ data: variables });
  };

  return (
    <div className='container mx-auto'>
      <h2 className='text-center text-2xl mb-4 font-bold'>
        <FormattedMessage {...messages.contactMe} />
      </h2>
      <ContactMeForm
        onSubmit={submit}
        loading={loading}
      />
      {data &&
        <FormattedMessage {...messages.sentMessage} />
      }
    </div>
  );
};
